export default __webpack_public_path__ + "static/media/EquivalentImg.02fa4139.jpg";